module.exports = __webpack_public_path__ + "static/media/green-star.709ca071.svg";